export default __webpack_public_path__ + "static/media/flexPlusBanner2x.2e2bb829.png";